import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule, ToolbarComponent, FooterComponent],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class SupportComponent {}
